<template>
  <unicom-modal
    v-model="mostrar"
    :largura="706"
    fechar
    @input="valor => fecharModal(valor)"
  >
    <div slot="header" class="pb-2">
      <div class="titulo negrito">
        <span style="margin-right: 24px"> Atendimento </span>
        <span class="codigo fonte-secundaria"
          >Código: {{ objetoModal.chaveReferencia }}</span
        >
      </div>
    </div>
    <div slot="body" class="medio">
      <unicom-linha :espacamento="false" class="linha-embaixo">
        <unicom-coluna sm="12" md="auto">
          <div>
            <span class="segunda-cor-fonte">CNPJ:</span> {{ objetoModal.cnpj }}
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" class="ml-auto mr-auto">
          <div>
            <span class="segunda-cor-fonte">CNES:</span> {{ objetoModal.cnes }}
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" class="mr-auto">
          <div>
            <span class="segunda-cor-fonte">Filial:</span>
            {{ objetoModal.filial ? objetoModal.filial.descricao : "" }}
          </div>
        </unicom-coluna>
      </unicom-linha>
      <unicom-linha :espacamento="false" class="mt-4">
        <unicom-coluna sm="auto" style="padding-right: 24px">
          <unicom-icone nome="phone" :especuraDoIcone="1.5" :tamanho="20" />
        </unicom-coluna>
        <unicom-coluna sm="8" md="auto">
          <unicom-linha :espacamento="false">
            <unicom-coluna sm="12" md="auto">
              <div>
                <span class="segunda-cor-fonte"> Telefone 1: </span>
                <span>
                  {{
                    mascaraTelefoneContato(
                      objetoModal.dddTelefonePrincipal,
                      objetoModal.telefonePrincipal
                    )
                  }}
                </span>
              </div>
            </unicom-coluna>
            <unicom-coluna
              sm="12"
              md="auto"
              :style="
                $breakpoint.smAndDown ? 'padding-top: 8px' : 'padding-left: 8px'
              "
            >
              <div>
                <span class="segunda-cor-fonte"> Telefone 2: </span>
                <span>
                  {{
                    mascaraTelefoneContato(
                      objetoModal.dddTelefoneSecundario,
                      objetoModal.telefoneSecundario
                    )
                  }}
                </span>
              </div>
            </unicom-coluna>
          </unicom-linha>
          <unicom-linha style="padding-top: 8px">
            <unicom-coluna sm="12">
              <div>
                <span class="segunda-cor-fonte"> Fax: </span>
                <span>
                  {{
                    mascaraTelefoneContato(objetoModal.dddFax, objetoModal.fax)
                  }}</span
                >
              </div>
            </unicom-coluna>
          </unicom-linha>
          <unicom-linha style="padding-top: 8px">
            <unicom-coluna sm="12">
              <div>
                <span class="segunda-cor-fonte"> WhatsApp: </span>
                <span>
                  {{
                    mascaraTelefoneContato(
                      objetoModal.dddWhatsapp,
                      objetoModal.whatsapp
                    )
                  }}
                </span>
              </div>
            </unicom-coluna>
          </unicom-linha>
        </unicom-coluna>
      </unicom-linha>
      <unicom-linha :espacamento="false" class="mt-4">
        <unicom-coluna sm="auto" style="padding-right: 24px">
          <unicom-icone nome="mail" :especuraDoIcone="1.5" :tamanho="20" />
        </unicom-coluna>
        <unicom-coluna sm="auto">
          <div>{{ objetoModal.email }}</div>
        </unicom-coluna>
      </unicom-linha>
      <unicom-linha :espacamento="false" class="mt-4">
        <unicom-coluna sm="auto" style="padding-right: 24px">
          <unicom-icone nome="map-pin" :especuraDoIcone="1.5" :tamanho="20" />
        </unicom-coluna>
        <unicom-coluna sm="8" md="auto">
          <div>
            {{ objetoModal.logradouro }}, {{ objetoModal.numero }},
            {{ objetoModal.bairro }}, {{ objetoModal.cidade }}.
          </div>
          <div style="padding: 8px 0">{{ objetoModal.uf }}</div>
          <div>{{ objetoModal.cep }}</div>
        </unicom-coluna>
      </unicom-linha>
      <div class="linha-embaixo" />
      <div class="medio negrito my-4">Grupos de serviço</div>
      <PesquisaGrupoServicos
        :listaGrupoServicos="
          objetoModal.gruposServico
            ? objetoModal.gruposServico.map(e => e.nome)
            : []
        "
      />
    </div>
    <div slot="footer" />
  </unicom-modal>
</template>

<script>
import PesquisaGrupoServicos from "./PesquisaGrupoServicos";
export default {
  components: {
    PesquisaGrupoServicos
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    objetoModal: {
      type: Object,
      default: () => {
        return {
          // bairro,
          // cep,
          // chaveReferencia,
          // cidade,
          // cnes,
          // cnpj,
          // dddFax,
          // dddTelefonePrincipal,
          // dddTelefoneSecundario,
          // dddWhatsapp,
          // email,
          // fax,
          // filial,
          // gruposServico,
          // logradouro,
          // numero,
          // telefonePrincipal,
          // telefoneSecundario,
          // uf,
          // whatsapp
        };
      }
    }
  },
  data() {
    return {
      mostrar: this.value
    };
  },
  methods: {
    fecharModal(valor) {
      if (!valor) {
        this.$emit("input", false);
      }
    },
    mascaraTelefoneContato(ddd, telefone) {
      if (!ddd || !telefone) return;
      return this.mascaraTelefone(this.zeroEsquerda(ddd, 2) + telefone);
    }
  },
  watch: {
    value() {
      this.mostrar = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.codigo {
  font-size: 14px;
  text-align: center;
  padding: 8px 12px;
  width: 68px;
  background: #00995d1a;
  border-radius: 8px;
  color: #00995d;
}
</style>
